import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';

const Confirmation = ({ show, proceed, title, message }) => (
  <div className={`modal fade ${show ? 'show' : 'hide'}`} style={{ display: "block", backgroundColor: "rgba(0,0,0,.15)" }} role="dialog" onClick={() => proceed(false)}>
    <div className="modal-dialog modal-lg" role="document">
      <div className="modal-content" style={{ color: 'darkblue' }}>
        <h5 className='popupTitle'>{title}</h5>
        <p className='popup-text'>{message}</p>
        <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button
            className="btn btn-cancel"
            onClick={() => proceed(false)}>
            NO
          </button>
          <button
            className="btn btn-save"
            onClick={() => proceed(true)}>
            YES
          </button>
        </div>
      </div>
    </div>
  </div>
);

export const confirm = createConfirmation(confirmable(Confirmation));